import { UNLICENSED } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShouldShowImporter = () => {
	const { core, software } = useAppEditions();

	return core !== UNLICENSED || software !== UNLICENSED;
};
